module.exports = __webpack_public_path__ + "static/media/womenSupportEachOther.af6d6aa5.png";